import { useCallback, useEffect, useState } from 'react';
import { API_BASE } from './api';

let healthPromise: Promise<{ demo_mode?: boolean; status?: string } | null> | null = null;

function loadHealth() {
  healthPromise ??= fetch(`${API_BASE.replace(/\/$/, '')}/health`)
    .then((res) => (res.ok ? res.json() : null))
    .catch(() => null);
  return healthPromise;
}

/** Health fetched once. */
export function useGatewayStatus(): { online: boolean | null; demo: boolean } {
  const [state, setState] = useState<{ online: boolean | null; demo: boolean }>({ online: null, demo: false });
  useEffect(() => {
    let alive = true;
    void loadHealth().then((body) => {
      if (alive) setState({ online: body !== null, demo: Boolean(body?.demo_mode) });
    });
    return () => {
      alive = false;
    };
  }, []);
  return state;
}

export function refreshBalance() {
  window.dispatchEvent(new Event('aiagg:balance'));
}

/** Escape closes drawer. */
export function useNavDrawer() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);
  const show = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);
  return { open, show, close };
}
